import { axios } from '../axios';
import { baseEnvironment } from '../environment/environment.base';
import { ResetCaseResponse } from './service-mappers/BaseMapper';

const v1Version = baseEnvironment.apiVersion1;
const v3Version = baseEnvironment.apiVersion3;
const resetCasesRoute = `${v1Version}${baseEnvironment.apiEndPoints.case.resetCases}`;
const allCasesRoute = `${v3Version}${baseEnvironment.apiEndPoints.case.allCases}`;
const updateCaseStatusRoute = `${v1Version}${baseEnvironment.apiEndPoints.case.updateCaseStatus}`;

export const getAllCases = async (
    offSet: number,
    searchText?: string
): Promise<any> => {
    try {
        let params = `?offset=${offSet}`;
        const searchParams = searchText ? `&search_text=${searchText}` : '';
        params = params + searchParams
        const response = await axios.get(`${allCasesRoute}${params}`);
        return response;
    } catch (error) {
        return error;
    }
};

export const updateCaseDetails = async (
    caseId: any,
    updateObject: any
): Promise<any> => {
    try {
        const response = await axios.put(`${updateCaseStatusRoute}/${caseId}`, updateObject);
        return response;
    } catch (error) {
        return error;
    }
};

export const resetCases = async(caseId:any):Promise<ResetCaseResponse> =>{
    const response = await axios.put(`${resetCasesRoute}/${caseId}`);
    return response.data
}